// Issues Station - Handles wine stains, repairs, additional services, etc.
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import BaseStationScreen from '../components/BaseStationScreen';

const IssuesStation: React.FC = () => {
  return (
    <BaseStationScreen
      stationId="issues"
      stationName="Issues & Problems"
      stationIcon={<AlertTriangle className="w-6 h-6" />}
      stationColor="#EF4444"
      showAdvanceButton={true}
      showCustomerContact={true}
      showDeliveryInfo={false}
    />
  );
};

export default IssuesStation;
